<!-- 販売制限エラー エラーに応じて表示内容を変える -->
<template>
  <ItemDialog ref="saleLimit" image-type="alert">
    <template #content-area>
      <p class="text-center">
        {{ props.message }}
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogSaleLimit",
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const saleLimit = ref(null);

    const openDialog = () => {
      saleLimit.value.open();
    };

    const closeDialog = () => {
      nativeHandlerService.returnNativeAppTopPage();
    };

    return {
      saleLimit,
      props,
      openDialog,
      closeDialog,
    };
  },
};
</script>
